import * as yup from "yup";

export const EPOSLOVANJE_EDIT_FORM_SCHEMA = yup.object({
  apiKey: yup.string().required("API ključ je obavezan"),
  companyVatId: yup.string().required("OIB je obavezan").matches(/^\d{11}$/, "OIB mora imati 11 znamenki"),
});
